import { ApolloClient, InMemoryCache, ApolloLink, Observable } from '@apollo/client';
// TODO: Remove once PingID auth is implemented. Azure AD auth is bypassed.

const backendUrl = `${process.env.REACT_APP_MIDDLEWARE_API_BASE_URL}graphql`;
const encodedUrl = `${process.env.REACT_APP_MIDDLEWARE_API_BASE_URL}graphql-encoded`;
console.log(`[Apollo] Backend URL configured as: ${backendUrl}`);
console.log(`[Apollo] Encoded endpoint: ${encodedUrl}`);

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

// Encoded transport link — base64-encodes the GraphQL body to bypass WAF SQLi inspection
const encodedHttpLink = new ApolloLink((operation, forward) => {
  return new Observable((observer) => {
    const { query, variables, operationName } = operation;
    const body = JSON.stringify({
      query: query.loc?.source?.body || '',
      variables,
      operationName,
    });
    const encoded = btoa(unescape(encodeURIComponent(body)));

    console.log(`[graphql-encoded] ▶ BEFORE fetch | Operation: ${operationName} | URL: ${encodedUrl}`);
    fetch(encodedUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', // send session cookie so Apollo context can read PingID user
      body: JSON.stringify({ data: encoded }),
    })
      .then((res) => {
        console.log(`[graphql-encoded] ✅ AFTER fetch | Operation: ${operationName} | HTTP status: ${res.status} ${res.statusText}`);
        return res.json();
      })
      .then((result) => {
        const hasErrors = result.errors && result.errors.length > 0;
        if (hasErrors) {
          console.error(`[graphql-encoded] ❌ GraphQL errors | Operation: ${operationName} |`, result.errors);
        } else {
          console.log(`[graphql-encoded] ✅ GraphQL success | Operation: ${operationName}`);
        }
        observer.next(result);
        observer.complete();
      })
      .catch((err) => {
        console.error(`[graphql-encoded] ❌ fetch FAILED | Operation: ${operationName} | Error:`, err.message);
        observer.error(err);
      });
  });
});

// Logging link — logs the backend URL and operation name on every GraphQL request
const loggingLink = new ApolloLink((operation, forward) => {
  console.log(`[Apollo] ▶ Request  | Operation: ${operation.operationName} | URL: ${encodedUrl}`);
  const startTime = Date.now();

  return forward(operation).map((response) => {
    const duration = Date.now() - startTime;
    const hasErrors = response.errors && response.errors.length > 0;

    if (hasErrors) {
      console.log(`[Apollo] Response  | Operation: ${operation.operationName} | URL: ${encodedUrl} | response.errors: ${response.errors} | response.errors.length: ${response.errors.length}`);
    } else {
      console.log(`[Apollo] Response | Operation: ${operation.operationName} | URL: ${encodedUrl} | duration: ${duration}ms`);
    }
    return response;
  });
});

// TODO: Replace with PingID token logic when implementing auth migration.
const apolloClient = new ApolloClient({
  link: ApolloLink.from([loggingLink, encodedHttpLink]),
  cache: new InMemoryCache(),
  defaultOptions
});

export default apolloClient;
